import cx from 'classnames';
import SVG from 'react-inlinesvg';
import MenuItemBadge from 'components/common/SidebarMenu/MenuItemBadge/MenuItemBadge';
import Tooltip from 'lib/Tooltip';
import { ButtonSize, IconButtonProps, IconButtonSize, IconButtonTheme, Theme } from './IconButton.types';

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  name,
  isDisabled = false,
  handleOnClick,
  theme = Theme.PLAIN,
  buttonSize = ButtonSize.SMALL,
  dataTestId,
  dataPendoId,
  ddActionName,
  className,
  title,
  badgeCount = 0,
}) => {
  return (
    <Tooltip tooltip={title}>
      <button
        type="button"
        aria-label={name}
        className={cx(
          'flex justify-center items-center border',
          IconButtonSize[buttonSize].buttonStyle,
          {
            'bg-neutral-200 cursor-not-allowed': isDisabled,
            [IconButtonTheme[theme].buttonStyle]: !isDisabled,
            relative: badgeCount > 0,
          },
          className,
        )}
        onClick={handleOnClick}
        disabled={isDisabled}
        data-test-id={dataTestId}
        data-pendo-id={dataPendoId}
        data-dd-action-name={ddActionName}
      >
        {badgeCount > 0 && <MenuItemBadge count={badgeCount} />}
        <SVG
          src={icon}
          className={cx(IconButtonSize[buttonSize].iconStyle, {
            'text-neutral-400': isDisabled,
            [IconButtonTheme[theme].iconColor]: !isDisabled,
          })}
        />
      </button>
    </Tooltip>
  );
};

export default IconButton;
